import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { BrandVisualKit } from 'types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface Data {
  brand_visual_kits: BrandVisualKit[]
}

const fetchBrandVisualKit = (workspaceId: number) => sendToApi<Data>(`/w/${workspaceId}/brand_visual_kits`)

export const useBrandVisualKits = (options?: UseQueryOptions<Data> & { workspaceId?: number }) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const workspaceId = options?.workspaceId || currentWorkspaceId

  return useQuery<Data>(
    ['workspaces', workspaceId, 'brand_visual_kits', 'list'],
    async () => {
      const res = await fetchBrandVisualKit(workspaceId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
